<ng-container [formGroup]="form">
  <td>
    <material-order-position-status [id]="position.position_id"
      [status]="position.status"
      [edit]="false"
      [deleted]="position.deleted">
    </material-order-position-status>
  </td>
  <td class="align-right">{{position.index}}</td>
  <td class="align-right">
    @if (position.delivery_index === 0) {
      <span>1</span>
    }
    @if (position.delivery_index > 0) {
      <strong>{{position.delivery_index + 1}}</strong>
    }
  </td>
  @if (groupPermitted) {
    <td>
      <a uiSref="a.material.inventory.update" target="_blank" [uiParams]="{variation: position.id}">
        {{position.variation_id}}
      </a>
    </td>
  }
  @if (!groupPermitted) {
    <td>
      {{position.variation_id}}
    </td>
  }
  <td>{{position.vendor_article_id}}</td>
  <td>{{position.article_name}}</td>
  <td>{{position.article_name_order}}</td>
  @for (field of fields; track field) {
    <td [ngClass]="{'align-right': field.isValueType('Number')}">
      @if (!(position.fields[field.html_name]|isNull)) {
        @switch (field.data_type) {
          @case ('Option') {
        <i class="fa" [ngClass]="{
          'fa-check':(position.fields[field.html_name] === true),
          'fa-times': (position.fields[field.html_name] === false)}"></i>
          }
          @case ('Ganzzahl') {
            {{ position.fields[field.html_name] | money:0 }}
          }
          @case ('Kommazahl') {
            {{ position.fields[field.html_name] | money }}
          }
          @default {
            {{ position.fields[field.html_name] }}
          }
        }
      }
    </td>
  }
  @if (!edit) {
    <td class="align-right">
      {{position.amount_ordered|money}}
      @if (position.amount_ordered_first_contact && (position.amount_ordered !== position.amount_ordered_first_contact)) {
        <span style="font-size: 8px"
          >
          <br/>{{position.amount_ordered_first_contact|money}}
        </span>
      }
    </td>
  }
  @if (edit) {
    <td>
      <input type="number"
        class="form-control align-right"
        formControlName="amount_ordered"
        [id]="'amount_ordered' + position.index">
    </td>
  }
  <td>{{position.unit}}</td>
  @if (!edit) {
    <td>
      @if (position.date_delivery) {
        {{position.date_delivery | date:'dd.MM.yyyy'}}
      }
      @if (!position.date_delivery) {
        -
      }
      @if (position.date_delivery_first_contact &&
        (position.date_delivery !== position.date_delivery_first_contact)) {
        <span style="font-size: 8px">
          <br />{{position.date_delivery_first_contact | date:'dd.MM.yyyy'}}
        </span>
      }
    </td>
  }
  @if (edit) {
    <td>
      <ev-datepicker class="form-control"
        [id]="'date_delivery' + position.index"
        [parser]="dateParser"
        [coreFormat]="true"
        [writeBack]="false"
        formControlName="date_delivery"
        [allDates]="true">
      </ev-datepicker>
    </td>
  }
  @if (!edit) {
    <td class="align-right">
      @if (position.price) {
        {{position.price|money:2}}&nbsp;€
      }
      @if (!position.price) {
        -
      }
    </td>
  }
  @if (edit) {
    <td class="align-right">
      <input class="form-control align-right" type="text" formControlName="price" [id]="'price_' + position.index">
    </td>
  }
  @if (!edit) {
    <td>
      {{position.note}}
    </td>
  }
  @if (edit) {
    <td>
      <input class="form-control" [id]="'note_' + position.index" formControlName="note">
    </td>
  }
  @if (('material.order.create'|HasPerm) && !order.date_deleted) {
    <td class="icon">
      @if (!edit && !position.deleted && groupPermitted) {
        <a class="click"
          title="Position bearbeiten"
          (click)="setEdit(true)"
          >
          <i class="fa fa-pencil row-icon"></i>
        </a>
      }
      @if (edit && !position.deleted) {
        <a class="click"
          title="Änderung speichern"
          (click)="update()"
          >
          <i class="fa fa-floppy-o row-icon"></i>
        </a>
      }
    </td>
  }
  @if (('material.order.create'|HasPerm) && !order.date_deleted) {
    <td class="icon">
      @if (edit && !position.deleted) {
        <a class="click"
          title="Abbrechen"
          (click)="setEdit(false)"
          >
          <i class="fa fa-times red_font row-icon"></i>
        </a>
      }
    </td>
  }
  @if (!order.date_deleted) {
    <td class="icon">
      @if (groupPermitted) {
        <a title="Position kopieren"
          [ngClass]="{click: !lockCopy}"
          (click)="copy()"
          >
          <i class="fa fa-plus row-icon" [ngClass]="{green: !lockCopy, gray_font: lockCopy}"></i>
        </a>
      }
    </td>
  }
  @if (!order.date_deleted) {
    <td class="icon">
      @if (position.status < 2) {
        <a class="click"
          [title]="toggleConfirmTooltip"
          (click)="toggleConfirmState()"
          >
          <i class="fa row-icon" [ngClass]="toggleConfirmIconClass"></i>
        </a>
      }
    </td>
  }
  @if (('material.order.create'|HasPerm)) {
    <td class="icon">
      @if (!position.deleted && (position.transactions.length === 0) && groupPermitted) {
        <a class="click"
          title="Position löschen"
          (click)="delete()"
          >
          <i class="fa fa-trash-o red_font row-icon"></i>
        </a>
      }
      @if (position.deleted && !order.date_deleted && groupPermitted) {
        <a class="click"
          title="Position wiederherstellen"
          (click)="deleteUndo()"
          >
          <i class="fa fa-undo row-icon"></i>
        </a>
      }
    </td>
  }
</ng-container>
